import { FileUrlDomainException } from '~/modules/TrophyMemories/Domain/FileUrlDomainException'
import { AbsoluteFileUrl } from '~/modules/TrophyMemories/Domain/AbsoluteFileUrl'
import { AudioThumbnailSvgFileUrl } from '~/modules/TrophyMemories/Domain/AudioThumbnailSvgFileUrl'
import { FileUrl } from '~/modules/TrophyMemories/Domain/FileUrl'

export class FileUrlParser {
  public static parseFrom (url: string): FileUrl {
    if (AudioThumbnailSvgFileUrl.canParse(url)) {
      return new AudioThumbnailSvgFileUrl()
    }

    if (AbsoluteFileUrl.canParse(url)) {
      return new AbsoluteFileUrl(url)
    }

    throw FileUrlDomainException.invalidFileUrl(url)
  }
}
